'use strict';

// Generated by CoffeeScript 2.3.2
(function () {
  var events;

  events = {
    namespaces: {},
    on: function on(event, cb, opts) {
      var options;
      if (this.namespaces == null) {
        this.namespaces = {};
      }
      this.namespaces[event] = cb;
      options = opts || false;
      this.addEventListener(event.split('.')[0], cb, options);
      return this;
    },
    off: function off(event) {
      if (this.namespaces != null && this.namespaces[event] != null) {
        this.removeEventListener(event.split('.')[0], this.namespaces[event]);
        delete this.namespaces[event];
      }
      return this;
    }
  };

  window.on = events.on;

  document.on = events.on;

  Element.prototype.on = events.on;

  window.off = events.off;

  document.off = events.off;

  Element.prototype.off = events.off;
}).call(undefined);